module.exports = __webpack_public_path__ + "media/images/related-photo-2-4b12d2c2b4fa3c01f8c17c4dc79aab5d.jpg";